export function wrapInMask(el) {
  const mask = document.createElement("div");
  mask.classList.add("c-text-mask");
  el.parentNode.insertBefore(mask, el);
  mask.appendChild(el);
  el.style.opacity = "1";
  return mask;
}

export function unwrapMask(mask) {
  const parent = mask.parentNode;
  if (!parent) return;
  while (mask.firstChild) parent.insertBefore(mask.firstChild, mask);
  parent.removeChild(mask);
}
